function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.6 16.9c.5.5.5 1.2 0 1.7-.2.2-.5.3-.9.3s-.6-.1-.9-.3L12 13.7l-4.9 4.9c-.3.3-.6.4-.9.4-.3 0-.6-.1-.9-.3-.5-.5-.5-1.2 0-1.7l4.9-4.9-4.8-5c-.5-.5-.5-1.2 0-1.7s1.2-.5 1.7 0l4.9 4.9 4.9-4.9c.5-.5 1.2-.5 1.7 0s.5 1.2 0 1.7L13.7 12l4.9 4.9z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
});

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default SvgClose;